import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _URLSearchParams from "@babel/runtime-corejs3/core-js/url-search-params";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from "vuex";
import { mapFields } from "@joandvgv/vuex-map-fields";
import { showBModal } from "@Shared/components/bootstrap/BModal";
import BoardsDropdown from "../../../../util-components/board/boards-dropdown";
import BoardsToolbar from "./header-components/boards-toolbar";
import BoardActionsDropdown from "./header-components/board-actions-dropdown";
import Loader from "./header-components/board-header-loader";
import { UPDATE_DEFAULT_BOARD, UPDATE_COLLABORATOR_SETTINGS, DOWNLOAD_CSV_EXPORT, ORDER_BOARDS, REMOVE_SELF_FROM_BOARD } from "@Broker/@Modules/clients/board/store/board-actions";
import { SELECTED_BOARD, COLLABORATION_ID, SELECTED_BOARD_TRACK_EMAILS } from "@Broker/@Modules/clients/board/store/board-getters";
import { SAVE_BOARD_VIEW } from "@Broker/@Modules/main/store/account/account-actions";
import CreateClientModal from "./modals/create-client-modal";
import { showToast } from "@Shared/utils/constants";
import { CURRENT_USER_USERNAME } from "@Broker/@Modules/main/store/account/account-getters";
import Amplitude from "@Shared/@Utils/amplitude";
import { debounce } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientBoardHeader",
  components: {
    BoardsDropdown,
    BoardsToolbar,
    BoardActionsDropdown,
    Loader,
    CreateClientModal
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      loadingBoardAction: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapFields("BoardStore", ["selectedBoardId", "clientProfileSearchString"])), mapState("BoardStore", ["boards"])), mapState("AccountStore", ["clientBoardView", "userDetails"])), mapGetters("AccountStore", [CURRENT_USER_USERNAME])), mapGetters("BoardStore", [SELECTED_BOARD, COLLABORATION_ID, SELECTED_BOARD_TRACK_EMAILS])), {}, {
    boardsOptions() {
      return _Object$values(this.boards.byId);
    },
    boardName() {
      return this.SELECTED_BOARD.name;
    },
    isOwner() {
      return this.SELECTED_BOARD.owner;
    },
    isDefaultBoard() {
      return this.isOwner && this.SELECTED_BOARD.default;
    },
    trackEmails() {
      return this.SELECTED_BOARD_TRACK_EMAILS(this.CURRENT_USER_USERNAME);
    },
    isDynamicView() {
      return this.clientBoardView === "dynamic";
    },
    searchFor() {
      return this.clientBoardView === "chart" ? this.$t("tables.filters.searchFor", {
        item: this.$tc("global.doorr.agent", 2)
      }) : this.$t("application.listing.searchForClients");
    }
  }),
  watch: {
    loading(value) {
      if (!value) this.createNewClientOnInit();
    },
    "boards.allIds"() {
      this.boardsOptions = _Object$values(this.boards.byId);
    }
  },
  activated() {
    if (!this.loading) this.createNewClientOnInit();
    this.boardsOptions = _Object$values(this.boards.byId);
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("BoardStore", [UPDATE_DEFAULT_BOARD, UPDATE_COLLABORATOR_SETTINGS, DOWNLOAD_CSV_EXPORT, ORDER_BOARDS, REMOVE_SELF_FROM_BOARD])), mapActions("AccountStore", [SAVE_BOARD_VIEW])), {}, {
    handleBoardSelect(event, {
      boardId
    }) {
      this.selectedBoardId = boardId;
      this.$emit("change-board");
    },
    async handleDropdownSelection(action = "create", data = {}) {
      switch (action) {
        case "create":
        case "duplicate":
          showBModal("board-details-modal", {
            action,
            data: this.SELECTED_BOARD
          }, this);
          break;
        case "edit":
          showBModal("board-details-modal", {
            action,
            data: this.SELECTED_BOARD
          }, this);
          break;
        case "create-column":
          showBModal("add-state-modal", {}, this);
          break;
        case "delete":
          showBModal("delete-board-modal", {
            boardId: this.SELECTED_BOARD.id
          }, this);
          break;
        case "set-default":
          this.updateDefaultBoard();
          break;
        case "manage-collaborators":
          showBModal("manage-collaborators-modal", {}, this);
          break;
        case "remove-as-collaborator":
          showBModal("remove-self-as-collab-modal", {}, this);
          break;
        case "manage-visibility":
          showBModal("manage-visibility-modal", {}, this);
          break;
        case "toggle-email-tracking":
          this.updateEmailTracking(data.trackEmails);
          break;
        case "toggle-view":
          this.SAVE_BOARD_VIEW({
            clientBoardView: data.boardView
          });
          this.clientProfileSearchString = "";
          break;
        case "export-csv":
          this.DOWNLOAD_CSV_EXPORT();
          break;
        case "changelog-summary":
          this.$emit("changelog-summary");
          break;
        default:
          break;
      }
    },
    handleOrderBoards(orderedBoards) {
      this.ORDER_BOARDS(orderedBoards);
    },
    updateDefaultBoard() {
      this.UPDATE_DEFAULT_BOARD({
        boardId: this.SELECTED_BOARD.id
      }).then(() => {
        showToast("success", "defaultBoardUpdated");
      });
    },
    updateEmailTracking: debounce(function (trackEmails) {
      const username = this.userDetails.username;
      const boardId = this.SELECTED_BOARD.id;
      const collaboratorId = this.isOwner ? 0 : this.COLLABORATION_ID(boardId, this.userDetails.username);
      const data = {
        boardId,
        trackEmails: !trackEmails,
        collaboratorId,
        username
      };

      //if its already on, we don't need to show a confirmation modal
      if (trackEmails) return this.UPDATE_COLLABORATOR_SETTINGS(data);
      showBModal("email-tracking-modal", data, this);
    }, 100),
    showCreateClient() {
      showBModal("create-client-modal", {}, this);
    },
    createNewClientOnInit() {
      const createNewClient = new _URLSearchParams(location.hash.split("?")[1]).get("createNewClient");
      if (createNewClient === "true") {
        this.$nextTick(() => {
          this.showCreateClient();
        });
      }
    },
    handleSearchChange: debounce(function (value) {
      this.clientProfileSearchString = value;
      Amplitude.logEvent("Board - search triggered", {
        data: {
          searchString: value
        }
      });
    }, 400)
  })
});